import AppWindowIcon from './app-window.svg';
import ArrowLeftIcon from './arrow-left.svg';
import ArrowLinkIcon from './arrow-link.svg';
import ArrowRightIcon from './arrow-right.svg';
import ArrowIcon from './arrow.svg';
import BcBaseIcon from './bc-base.svg';
import BcEthIcon from './bc-eth.svg';
import BoostIcon from './boost.svg';
import BridgeIcon from './bridge.svg';
import CancelIcon from './cancel.svg';
import ChatIcon from './chat.svg';
import CheckIcon from './check.svg';
import ClaimIcon from './claim.svg';
import CloseIcon from './close.svg';
import CoinIcon from './coin.svg';
import ColorBucketIcon from './color-bucket.svg';
import ConnectionIcon from './connection.svg';
import DarkDisplayModeIcon from './dark-display-mode.svg';
import DisconnectIcon from './disconnect.svg';
import DiscordIcon from './discord.svg';
import DownloadActionIcon from './download-action.svg';
import DownloadIcon from './download.svg';
import EmojiLoadingIcon from './emoji-loading.svg';
import EmojiMehIcon from './emoji-meh.svg';
import ErrorIcon from './error.svg';
import ExpandIcon from './expand.svg';
import FilterIcon from './filter.svg';
import FlipbookIcon from './flipbook.svg';
import GearIcon from './gear.svg';
import GiphyIcon from './giphy.svg';
import HyperlinkIcon from './hyperlink.svg';
import InfoIcon from './info.svg';
import InstagramIcon from './instagram.svg';
import LanguageIcon from './language.svg';
import LightDisplayModeIcon from './light-display-mode.svg';
import LoadingIcon from './loading.svg';
import LockIcon from './lock.svg';
import MenuIcon from './menu.svg';
import MoreActionIcon from './more-icon.svg';
import NotConnectedIcon from './not-connected.svg';
import PersonaLogoCompact from './persona-logo-compact.svg';
import PersonaLogo from './persona-logo.svg';
import SearchIcon from './search.svg';
import ShareIcon from './share.svg';
import SortAscendingIcon from './sort-ascending.svg';
import SortDescendingIcon from './sort-descending.svg';
import SortIcon from './sort.svg';
import StakeIcon from './stake.svg';
import SuccessIcon from './success.svg';
import TelegramIcon from './telegram.svg';
import TileHyperLinkIcon from './tile-hyperlink.svg';
import TwitterIcon from './twitter.svg';
import UnaAmountIcon from './una-amount-icon.svg';
import UnagiIcon from './unagi-icon.svg';
import UnstakeIcon from './unstake.svg';
import WiFiAntenna from './wifi-antenna.svg';

// Use any icon to export svg type
export type SvgIconComponent = typeof AppWindowIcon;

export {
  AppWindowIcon,
  ArrowIcon,
  ArrowLinkIcon,
  BcBaseIcon,
  BcEthIcon,
  BoostIcon,
  BridgeIcon,
  CancelIcon,
  CheckIcon,
  ClaimIcon,
  CloseIcon,
  ColorBucketIcon,
  ConnectionIcon,
  DarkDisplayModeIcon,
  DisconnectIcon,
  DiscordIcon,
  DownloadActionIcon,
  DownloadIcon,
  EmojiLoadingIcon,
  EmojiMehIcon,
  ErrorIcon,
  ExpandIcon,
  FilterIcon,
  FlipbookIcon,
  GearIcon,
  HyperlinkIcon,
  InfoIcon,
  InstagramIcon,
  LanguageIcon,
  LightDisplayModeIcon,
  LoadingIcon,
  LockIcon,
  MenuIcon,
  MoreActionIcon,
  PersonaLogo,
  PersonaLogoCompact,
  SearchIcon,
  ShareIcon,
  SortAscendingIcon,
  SortDescendingIcon,
  SortIcon,
  StakeIcon,
  SuccessIcon,
  TwitterIcon,
  UnaAmountIcon,
  UnagiIcon,
  UnstakeIcon,
  WiFiAntenna,
  ArrowLeftIcon,
  ArrowRightIcon,
  ChatIcon,
  NotConnectedIcon,
  TileHyperLinkIcon,
  TelegramIcon,
  GiphyIcon,
  CoinIcon,
};
